module.exports = __webpack_public_path__ + "static/img/00336v.67c4a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00336v.jpg
// module id = lJBh
// module chunks = 1